import { BaseModel, propertyChangedArguments } from "../BaseModel";

export class TherapistStatusHistoryModel extends BaseModel {

    constructor(source?: TherapistStatusHistoryModel) {
        super();
        if (source != null) {
            this.copyIn(source);
        }
        else
        {
            this._therapistStatusHistoryID = 0;
            this._therapistID = 0;
            this._therapistStatusID = 0;
        }
    }

// private properties
    _therapistStatusHistoryID: number = 0;
    _therapistID: number = 0;
    _therapistStatusID: number = 0;
    _changeDateTime: Date = new Date();

// public properties
    public get therapistStatusHistoryID(): number
    {
        return this._therapistStatusHistoryID;
    }
    public set therapistStatusHistoryID(v: number)
    {
        if (v !== this._therapistStatusHistoryID)
        {
            this._therapistStatusHistoryID = v;
            this.propertyChanged.emit(new propertyChangedArguments("therapistStatusHistoryID", this));
        }
    }

    public get therapistID(): number
    {
        return this._therapistID;
    }
    public set therapistID(v: number)
    {
        if (v !== this._therapistID)
        {
            this._therapistID = v;
            this.propertyChanged.emit(new propertyChangedArguments("therapistID", this));
        }
    }

    public get therapistStatusID(): number
    {
        return this._therapistStatusID;
    }
    public set therapistStatusID(v: number)
    {
        if (v !== this._therapistStatusID)
        {
            this._therapistStatusID = v;
            this.propertyChanged.emit(new propertyChangedArguments("therapistStatusID", this));
        }
    }

    public get changeDateTime(): Date
    {
        return this._changeDateTime;
    }
    public set changeDateTime(v: Date)
    {
        if (v !== this._changeDateTime)
        {
            this._changeDateTime = v;
            this.propertyChanged.emit(new propertyChangedArguments("changeDateTime", this));
        }
    }


    override assignChildren(): void {
        super.assignChildren();
    }

    copyIn(source: TherapistStatusHistoryModel): void {
        if (source == null) return;
        this._therapistStatusHistoryID = source.therapistStatusHistoryID;
        this._therapistID = source.therapistID;
        this._therapistStatusID = source.therapistStatusID;
        this._changeDateTime = source.changeDateTime;
    }


}
